import React from "react";
import "./legal.css";

export default function PrivacyPolicy() {
  const lastUpdated = "March 5, 2026";

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="legal-container">
          <p className="legal-badge">ingiwebservices</p>
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-subtitle">
            This Privacy Policy explains how we collect, use, disclose, and protect your information.
          </p>
          <p className="legal-updated">Last updated: {lastUpdated}</p>
        </div>
      </div>

      <div className="legal-container legal-card">
        <section className="legal-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><b>Contact details</b> (name, email, phone) when you submit forms or request a quote.</li>
            <li><b>Business/project information</b> you provide (requirements, timeline, budget, messages).</li>
            <li><b>Usage data</b> (pages visited, approximate location, device/browser info) via analytics tools.</li>
            <li><b>Cookies</b> and similar technologies to improve website performance and experience.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To respond to inquiries, provide quotes, and deliver requested services.</li>
            <li>To operate, maintain, and improve our website and offerings.</li>
            <li>To send service-related updates and communications you request.</li>
            <li>To detect, prevent, and address security or technical issues.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Sharing & Disclosure</h2>
          <p>
            We do not sell your personal data. We may share information with trusted third parties only as needed:
          </p>
          <ul>
            <li><b>Service providers</b> (hosting, analytics, email, customer support) to operate our business.</li>
            <li><b>Legal requirements</b> if required to comply with law, regulation, or legal process.</li>
            <li><b>Business transfers</b> in the event of a merger, acquisition, or asset sale.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Cookies & Analytics</h2>
          <p>
            Cookies help remember preferences and understand site usage. You can control cookies through your browser
            settings. Disabling cookies may impact some features.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Data Security</h2>
          <p>
            We use reasonable administrative, technical, and physical safeguards to protect your information.
            However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Retention</h2>
          <p>
            We retain personal data only as long as necessary for the purposes described here, unless a longer retention
            period is required or permitted by law.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Your Rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct, delete, or object to processing of your
            personal information. To request, contact us using the details below.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Children’s Privacy</h2>
          <p>
            Our services are not directed to children under 13 (or the age required by local law). We do not knowingly
            collect personal information from children.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Contact Us</h2>
          <div className="legal-contact">
            <p><b>Email:</b> hello@ingiwebservices.com</p>
            <p><b>Phone:</b> +1 (800) 555-4567</p>
            <p><b>Address:</b> 200 Innovation Drive, San Jose, CA 95101</p>
          </div>
        </section>

        <div className="legal-footer-note">
          If you have questions about this Privacy Policy, contact us and we’ll help.
        </div>
      </div>
    </div>
  );
}